import React, { useEffect, useState } from "react";
import "../../styles/physio.css";
import heroImg from "../../assets/working-doctor.jpg"
import { useNavigate } from "react-router-dom";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import { physiosPageContent } from "../../data/physiosPageContent";

// Hero section for the Physiotherapist marketing page
export default function PhysioHero() {
  const currentLang = useCurrentLang();
  const navigate = useNavigate();
  const t = physiosPageContent[currentLang];
  const [fade, setFade] = useState(0); // 0 = full image, 1 = fully faded

  const max = 600; // how many pixels to finish fade (tune this)

  useEffect(() => {
    const onScroll = () => {
      const ratio = Math.min(window.scrollY / max, 1); // 0 → 1
      setFade(ratio);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);


  const opacity = 0.85 * (1 - fade) + 0 * fade; // from 0.85 to 0.2

  const goPricingPhysio = () => {
    navigate(`/${currentLang}/pricing-physios`)
  }
  const goPhysioWaitlist = () => {
    navigate(`/${currentLang}/waitlist-physios`)
  }
  
  return (
    <section
      id="hero"
      className="physio-section physio-hero"
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundImage: `url(${heroImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity,
          transition: "opacity 0.25s ease-out",
          pointerEvents: "none",
          zIndex: -1,
        }}
      />

      <div
        className="glass-card"
        style={{
          position: "relative",
          zIndex: 2,
          padding: "20px 20px 56px 20px",
        }}
      >
        <span className="physio-eyebrow">{t.physioHero.s}</span>
        <h1>
          {t.physioHero.t1}
          <br />
          <span>{t.physioHero.t2}</span>
        </h1>
        <p className="hero-lead">
          {t.physioHero.desc}
        </p>

        <div className="physio-hero-actions">
          <button onClick={goPhysioWaitlist} className="btn-primary-physio">
            {t.physioHero.join}
          </button>
          <button onClick={goPricingPhysio} className="btn-ghost-physio">
            {t.physioHero.pricing}
          </button>
        </div>

        <div
          style={{
            position: "absolute",
            left: "50%",
            bottom: "-16px",
            transform: "translateX(-50%)",
            zIndex: 3,
          }}
        >
          <div
            className="scroll-arrow"
            style={{
              width: 32,
              height: 32,
              borderRadius: "999px",
              border: "2px solid #EEF5FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#EEF5FF",
              animation: "bounce 1.4s infinite",
              background: "rgba(23, 107, 135, 0.2)",
              backdropFilter: "blur(6px)",
              WebkitBackdropFilter: "blur(6px)",
            }}
          >
            ˅
          </div>
        </div>
      </div>

      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(6px); }
          }
        `}
      </style>
    </section>
  );
}
